// LoadingsForm.jsx
import { useState } from "react"
import "../../css/DemoCode.css"

/**
 * Sample code for creating a multi-slider interface.
 * The charts, models, and maps are all loaded in using swmmNode
 * and the model is processed using swmmWasm. File loading,
 * data processing, and chart and map display are provided by 
 * abstracted swmmReact interactions with swmmNode and swmmWasm.
 * 
 * @param {JSON} model A state-controlled SWMM model in JSON format.
 * @param {function} setModel state-controlled update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function LoadingsForm({model, setModel, fullModel, target}) {
  const [pollutantIDs]   = useState((Object.keys(fullModel.POLLUTANTS).length===0?[]:Object.keys(fullModel.POLLUTANTS)))

  const updateValue = (val, type) => {
    if(model && model.LOADINGS){
      setModel(prev => ({
        ...prev,
        LOADINGS:{
          ...prev.LOADINGS,
          [target]: {
            ...prev.LOADINGS[target],
            [type]: {
              InitLoad: val
            }
          }
        }
      }))
    }
  }

  if(model){
    return(
      <>
      {
        <>
          {(
            target && 
            target.length > 0 && 
            pollutantIDs.map((id)=>(
              <label className='editor-small' key={'InitLoad'+target+id}>{id}
                <input  type = "text"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{/*setReceivingNode(e.target.value);*/ updateValue(e.target.value, id)}}
                        value={model.LOADINGS[target][id].InitLoad}
                        id={'InitLoad'+target+id}
                />
              </label>
            ))
          )}
        </>
      }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}